import React from "react";
import { LegalLayout, Section, Bullets } from "@/components/legal/LegalLayout";
import { PRIVACY_EMAIL } from "@/constants/legal";

export default function CookiePolicy() {
  return (
    <LegalLayout
      slug="cookie-policy"
      title="Cookie Policy"
      subtitle="This Cookie Policy explains how HostGuard uses cookies and similar technologies (such as browser local storage) when you use our website and application."
    >
      <Section title="1. What are cookies?">
        <p>Cookies and similar technologies are small data files stored on your device. We use them to keep you signed in, remember your preferences, keep the service secure, and understand how the product is used so we can improve it.</p>
      </Section>

      <Section title="2. Essential cookies">
        <p>These are necessary for the website and app to function. They cannot be switched off in our systems. They include security and load-balancing cookies and storage needed to deliver core features.</p>
      </Section>

      <Section title="3. Authentication cookies">
        <p>We use authentication tokens (stored in your browser) to keep you securely signed in to your account and to protect access to your private assessments and settings. Without these you would need to log in on every page.</p>
      </Section>

      <Section title="4. Analytics cookies">
        <p>These help us understand, in aggregate, how visitors use HostGuard — for example which pages are visited and where errors occur. The data is used to improve usability and reliability and is not used to identify you personally.</p>
      </Section>

      <Section title="5. Performance cookies">
        <p>Performance technologies help us monitor and improve the speed and stability of the service, such as measuring load times and diagnosing technical issues.</p>
      </Section>

      <Section title="6. Managing cookies">
        <p>You can control or delete cookies through your browser settings. Please note that disabling essential or authentication cookies will prevent you from signing in and using core features of HostGuard.</p>
      </Section>

      <Section title="7. Contact">
        <p>Questions about this Cookie Policy can be directed to <a href={`mailto:${PRIVACY_EMAIL}`} className="font-medium text-primary hover:underline">{PRIVACY_EMAIL}</a> or via our <a href="/contact" className="font-medium text-primary hover:underline">Contact page</a>.</p>
      </Section>
    </LegalLayout>
  );
}
